var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-64 bg-gray-300 overflow-hidden relative cursor-pointer",on:{"click":_vm.openDetails}},[_c('single-image',{attrs:{"image":_vm.newsEntry.image || _vm.category.image}}),_c('div',{staticClass:"absolute inset-0 group-hover:opacity-50 transition-opacity duration-150",style:({
      background:
        'linear-gradient(0deg, ' +
        _vm.hexToRgbA(_vm.category.color, 0.8) +
        ' 0%, ' +
        _vm.hexToRgbA(_vm.category.color, 0) +
        ' 80%)',
    })}),_c('div',{staticClass:"z-20 text-white tracking-wider grid grid-cols-auto-1 gap-2"},[_c('div',{staticClass:"absolute bottom-0 inset-x-0 z-30 p-4 grid grid-cols-1-auto",style:({
        textShadow:
          '2px 2px 6px ' +
          _vm.hexToRgbA(_vm.category.color, 1) +
          ', 1px 1px 4px rgba(0,0,0,0.8)',
      })},[_c('div',[_c('h2',{staticClass:"mb-0 leading-tight"},[_vm._v("\n          "+_vm._s(_vm.newsEntry.title)+"\n        ")]),_c('p',{staticClass:"font-light"},[_vm._v("\n          "+_vm._s(_vm.momentFormat(_vm.newsEntry.published_at, "DD.MM.YYYY"))+"\n        ")])]),_c('div',{staticClass:"self-end"},[_c('icon',{attrs:{"name":_vm.category.icon,"size":"1.8em"}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }